import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { TextMobile } from '@alfa-bank/site-text-v2/mobile';

import { IconCross } from '../icon-cross/cross';
import { IconButton } from '../icon-button';

import type { IDepsDesktop, IDepsMobile, TInputDesktop, TInputMobile } from './models';
import { IconInput as ComponentInput } from './icon-input';
import styles from './styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const IconInput = createWidget<IDepsDesktop, TInputDesktop>({
    styles,
    Text,
    IconButton,
    IconCross,
})(ComponentInput);

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const IconInputMobile = createWidget<IDepsMobile, TInputMobile>({
    styles,
    Text: TextMobile,
    IconButton,
    IconCross,
})(ComponentInput);
